import { useEffect, useState, useRef } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { FortknoxService } from "../../../../services/FortknoxService";
import { closelightbox } from "../../../../util/Functions";

export const useQueueManager = (
    open: boolean,
    changeAlert: ChangeAlertCallbackType
) => {
    const fortknoxService = useRef<FortknoxService>();

    const [zPos, setZPos] = useState(45);
    const [form, setForm] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState("");
    const [isValidForm, setisValidForm] = useState<boolean>(true);

    const onHandleChange = (key, e) => {
        let f = form ? form : {};
        let er = error;

        let value = e && e["target"] ? e["target"]["value"] : String(e) ? e : e["props"]["value"];

        if (key.includes("active")) {
            f[key] = value === "true" ? true : false;
        } else if (key === "task_per_minute") {
            f[key] = Number(value);
        } else {
            f[key] = value;
        }

        if (!value) {
            key && (er = "Campo obligatorio");
        } else {
            key && (er = "");
        }

        setForm(JSON.parse(JSON.stringify(f)));
        setError(JSON.parse(JSON.stringify(er)));
        validateForm(f, er);
    };

    const validateForm = (f, e) => {
        if (f["queue_id"] && !e) {
            setisValidForm(false);
        } else {
            setisValidForm(true);
        }
    };

    const onConfirm = async (item) => {
        setLoading(true);
        setZPos(-1);

        const response = await fortknoxService.current[action](item);
        if (response["data"]?.response === "OK") {
            changeAlert(true, "success", "La acción se ejecutó con éxito");
            setZPos(45);
            setLoading(false);
            onClose();
        } else {
            changeAlert(true, "error", response["message"] || response["data"]["message"] || "Error al insertar documento");
            setZPos(45);
            setLoading(false);
        }
    };

    const onClose = () => {
        closelightbox();
    };

    useEffect(() => {
        fortknoxService.current = new FortknoxService(changeAlert);

        if (!open) {
            setForm(null);
            setError(null);
            setisValidForm(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        zPos,
        form,
        error,
        action,
        loading,
        isValidForm,
        onHandleChange,
        onConfirm,
        setAction,
        setForm,
        onClose,
    };
};
